import { useEffect } from "react";

const CHATBOT_SCRIPT_ID = "genesis-chatbot-widget";

export default function ChatbotWidget() {
    useEffect(() => {
        if (document.getElementById(CHATBOT_SCRIPT_ID)) {
            return;
        }

        const script = document.createElement("script");
        script.id = CHATBOT_SCRIPT_ID;
        script.src =
            "https://chatbot.genesisrecovery.ai/staticfiles/widget/genesisbot.bce2b6f04e6f.js";
        script.defer = true;
        script.dataset.botId = "af605c3c-2850-4608-baf0-55ecd30828bc";
        script.dataset.apiKey =
            "gnb_live_J9tAcL-OspuHUH-tmzd8oCYuy2PaNB-l0gRsFOp0iO8jV-vJgRHIPQ";
        script.dataset.host = "https://chatbot.genesisrecovery.ai";
        script.dataset.title = "Ask Hope";

        document.body.appendChild(script);

        return () => {
            document.getElementById(CHATBOT_SCRIPT_ID)?.remove();
        };
    }, []);

    return null;
}
